import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import createHistory from 'history/createBrowserHistory';
import CssBaseline from '@material-ui/core/CssBaseline';
import { PersistGate } from 'redux-persist/integration/react';

import App from './app/app.container';
import Tasks from './app/app.tasks.container';

import persistedCombinedRootReducer from './app/reducers';
import appSagas from './app/sagas';

import refreshAt from './app/utils/refreshAt';

import { ThreeHorseLoading } from 'react-loadingg';

class Root extends Component {
  constructor(props) {
    super(props);
    this.state = {
      store: null,
      history: null,
      persistor: null,
    };

    const sagaMiddleware = createSagaMiddleware();

    /* eslint-disable */
    const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;
    /* eslint-enable */

    const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware, logger));
    const history = createHistory();

    const store = createStore(persistedCombinedRootReducer, enhancer);

    sagaMiddleware.run(appSagas);
    const persistor = persistStore(store, {
      key: 'root-waiter',
    });

    this.state = ({
      store,
      persistor,
      history
    });

    // reload page between 4:00 AM and 4:15 AM (15-minute jitter window)
    refreshAt(4, 0, 0, 15);
  }

  render() {
    if (!this.state.store) {
      return null;
    }

    return (
      <Provider store={this.state.store}>
        <PersistGate loading={this.renderLoadingPage()} persistor={this.state.persistor}>
          <CssBaseline />
          <Tasks />
          <App history={this.state.history} />
        </PersistGate>
      </Provider>
    );
  }

  renderLoadingPage() {
    return (
      <ThreeHorseLoading
        color="#3f50b5"
        size="large" />
    );
  }
}

export default Root;
